// extracted by mini-css-extract-plugin
export default {"span":"CategoryTitle_span__KKIpZ"};